import React, { useState } from 'react';
import { Typography, Button, Avatar as AntdAvatar, Card, Select, DatePicker, Checkbox, Divider } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { BlueArrow } from 'assets';
import { ticketDetailedMessages } from 'messages/ticket-detailed.messages';
import Avatar from 'components/common/avatar/Avatar';
import dayjs from 'dayjs';
import { TicketDetail } from 'types';
import progressIcon from '../../assets/svg/progressing-setting.svg';
import { requestform } from 'messages';
import { useLocation } from 'react-router-dom';
import { GetReasonOutageService } from 'hooks/request-form';
import { TicketEventDto } from 'types/dto/ticket';
import { useUser } from 'hooks';

interface RequestDetailProcessingProps {
  requestItem: TicketDetail | null;
  processingContent: string;
  isHistory: boolean;
  setProcessingContent: (value: string) => void;
  setAssignUserInUnit?: (value: number) => void;
  setOutageReasonId?: (value: number) => void;
  setDatePowerRestore?: (value: Date) => void;
  setIsPowerRestore?: (value: boolean) => void;
  setRequestUpdateTicketFollowUpContent?: (value: string) => void;
  isSecondCall?: boolean;
  followUpOptions?: {
    isRequestMultipleTime: boolean;
    isNotOnTime: boolean;
    isOutageEntireArea: boolean;
    isNotRequestToSendSms: boolean;
  };
  setFollowUpOptions?: React.Dispatch<React.SetStateAction<{
    isRequestMultipleTime: boolean;
    isNotOnTime: boolean;
    isOutageEntireArea: boolean;
    isNotRequestToSendSms: boolean;
  }>>
}


const formatEventDate = (date?: string) => {
  if (!date) return '';
  const formatted = dayjs(date).format('DD/MM/YYYY - HH:mm');
  const [datePart, timePart] = formatted.split('-');
  return (
    <>
      {timePart}
      <Typography.Text className='relative bottom-1 text-2xl'>.</Typography.Text> {datePart}
      <Typography.Text className='relative bottom-1 text-2xl'>.</Typography.Text>{' '}
    </>
  );
};

const parseCurrentContent = (content: string) => {
  try {
    const parsed = JSON.parse(content);
    if (parsed && typeof parsed === 'object' && 'numOfRequests' in parsed) {
      return `Số lần gọi: ${parsed.numOfRequests}`;
    }
  } catch (error) {
    // Nội dung không phải JSON
  }
  return content;
};

const EventItem: React.FC<{ event: TicketEventDto; isFirstEvent: boolean }> = ({ event, isFirstEvent }) => {
  //const { user: eventUser } = useUser(event.createdBy);

  return (
    <div className='flex items-center justify-between py-2 relative'>
      {isFirstEvent && (
        <div className='absolute -left-8 top-1/2 -translate-y-1/2 rounded-full border bg-white p-2'>
          <BlueArrow />
        </div>
      )}

      <div className='flex-1 mx-4 w-full'>
        {isFirstEvent && (
          <div className='flex items-center justify-between'>
            <div className='text-[14px] italic text-[#141414]'>
              {dayjs(event.createdAt).format('HH:mm - DD/MM/YYYY')} bởi <Typography.Text className=''>{event?.createdByName}</Typography.Text> •{' '}
              {/* {eventUser?.organizationUnit?.name} */}
              {event?.createdByOrganizationUnitName}
            </div>
            <Avatar name={event.createdByName} size={32} />
          </div>
        )}

        <Typography.Text className='text-[16px]/[18px] font-semibold text-[#141414]'>
          {event.actionType?.name}
        </Typography.Text>

        <div className='mt-2 rounded-[5px] border bg-[#F7F8F9] p-4 text-[16px]/[20px] text-[#141414]'>
          {parseCurrentContent(event.currentContent)}
        </div>
      </div>


    </div>
  );
};


const TicketDetailedIProcessing: React.FC<RequestDetailProcessingProps> = ({
  requestItem,
  processingContent,
  setProcessingContent,
  setAssignUserInUnit,
  setOutageReasonId,
  setDatePowerRestore,
  setIsPowerRestore,
  setRequestUpdateTicketFollowUpContent,
  isSecondCall,
  isHistory,
  followUpOptions,
  setFollowUpOptions
}) => {
  const [isShow, setIsShow] = useState(false);
  const setShowAll = () => setIsShow(true);
  const location = useLocation();


  const { optionsList, optionsCount, optionLoading } = GetReasonOutageService(16);

  const events = requestItem?.ticketEvents || [];

  const hasMultipleEvents = events.length > 1;

  const handleDatePowerRestoreChange = (value: dayjs.Dayjs) => setDatePowerRestore?.(value.toDate());
  const handlePowerRestoreChange = (checked: boolean) => setIsPowerRestore?.(checked);
  const [isShowAllEvents, setIsShowAllEvents] = useState(false);
  const toggleShowAll = () => {
    setIsShowAllEvents((prev) => !prev);
  };
  const sortedEvents = [...events].sort((a, b) => dayjs(a.createdAt).valueOf() - dayjs(b.createdAt).valueOf());
  const latestEvent = sortedEvents[sortedEvents.length - 1];
  const remainingEvents = sortedEvents.slice(0, -1);




  const groupEventsByBatchUuid = (events: (TicketEventDto | undefined)[]) => {
    return events.reduce((acc, event) => {
      if (!event || !event.batchUuid) return acc; // ⛔ bỏ qua nếu không hợp lệ

      const { batchUuid } = event;
      if (!acc[batchUuid]) {
        acc[batchUuid] = [];
      }
      acc[batchUuid].push(event);
      return acc;
    }, {} as Record<string, TicketEventDto[]>);
  };

  const groupedEvents = groupEventsByBatchUuid(
    isShowAllEvents ? sortedEvents : latestEvent ? [latestEvent] : []
  );


  //const { user } = useUser(12);

  return (
    <Card className='border-none'>
      {requestItem?.serviceType?.code === 'baoMatDien' && requestItem?.status.code !== 'CHOTIEPNHAN' && (
        <div className='space-y-2 pb-5'>
          <div className='flex w-full items-center space-x-6'>
            <div className='w-1/5'>
              <Typography.Text className='text-[16px]/[16px] text-[#6C737E] text-nowrap'>
                {requestform.reasonOutage}
              </Typography.Text>
            </div>
            <Typography.Text className='text-[16px]/[16px] text-[#000000]'>
              {
                requestItem?.additionalInfo?.outageReasonId != null
                  ? optionsList.find((option) => option.optionId === requestItem?.additionalInfo?.outageReasonId)
                    ?.name
                  : optionsList[0]?.name
              }
            </Typography.Text>
            {/* <Select
              loading={optionLoading}
              className='w-full'
              disabled={requestItem?.status?.code === 'HOANTAT' || isHistory}
              defaultValue={
                requestItem?.additionalInfo?.outageReasonId != null
                  ? optionsList.find((option: any) => option.optionId === requestItem.additionalInfo.outageReasonId)
                    ?.optionId
                  : optionsList[0]?.optionId
              }
              style={{ width: 200 }}
              onChange={(value) => setOutageReasonId && setOutageReasonId(value)}
              options={[
                ...optionsList.map((option: any) => ({
                  value: option.optionId,
                  label: option.code + ' ' + option.name
                }))
              ]}
            /> */}
          </div>

          <div className='flex w-full items-center space-x-3'>
            <div className='w-1/5'>
              <Typography.Text className='text-[16px]/[16px] text-[#6C737E]'>{requestform.timeOutage}</Typography.Text>
            </div>

            <div className='flex w-full items-center justify-between'>
              <Typography.Text className='text-[16px]/[16px] text-[#000000]'>
                {requestItem?.additionalInfo?.outageAt
                  ? dayjs(requestItem?.additionalInfo?.outageAt).format('DD/MM/YYYY HH:mm')
                  : ''}
              </Typography.Text>

              <div>
                <div className='flex items-center space-x-3'>
                  <Typography.Text className='text-[16px]/[16px] text-[#6C737E]'>
                    {requestform.datePowerRestored}
                  </Typography.Text>
                  <Typography.Text className='text-[16px]/[16px] text-[#000000]'>
                    {requestItem?.additionalInfo?.powerRestorationAt
                      ? dayjs(requestItem?.additionalInfo?.powerRestorationAt).format('DD/MM/YYYY HH:mm')
                      : ''}
                  </Typography.Text>
                  {/* <DatePicker
                    value={
                      requestItem?.additionalInfo?.powerRestorationAt
                        ? dayjs(requestItem.additionalInfo.powerRestorationAt)
                        : undefined
                    }
                    showTime={{ format: 'HH:mm:ss' }}
                    format='DD/MM/YYYY HH:mm:ss'
                    onChange={handleDatePowerRestoreChange}
                    placeholder='Ngày giờ có điện'
                    disabled={requestItem?.status?.code === 'HOANTAT' || isHistory}
                  /> */}

                </div>
              </div>
            </div>
          </div>

          {/* {!isHistory && (
            <>
              {requestItem?.status.code !== 'HOANTAT' && (
                <Checkbox onChange={(e) => handlePowerRestoreChange(e.target.checked)}>
                  <Typography.Text className='text-[16px]/[16px] text-[#000000]'>
                    {requestform.isPowerRestore}
                  </Typography.Text>
                </Checkbox>
              )}
            </>
          )} */}
        </div>
      )}
      <Divider className='mt-[20px] bg-[#D4D8DE]' />
      <div className='flex items-center space-x-3'>
        <img src={progressIcon} alt='' />
        <Typography.Text className='text-[18px]/[22px] font-semibold text-[#141414]'>
          {requestform.processingTitle}
        </Typography.Text>
      </div>




      {/* Timeline */}
      <div className='mt-[20px]'>
        {isSecondCall && followUpOptions && setFollowUpOptions && (
          <div className='pb-3'>
            <TextArea
              placeholder='Nội dung phản hồi'
              autoSize={{ minRows: 5, maxRows: 10 }}
              className='rounded-lg bg-[#F7F8F6]'
              value={processingContent}
              onChange={(e) => setProcessingContent(e.target.value)}
            />
            <div className='mt-4 space-y-2'>
              {/* <Checkbox
                checked={followUpOptions.isRequestMultipleTime}
                onChange={(e) =>
                  setFollowUpOptions((prev) => ({
                    ...prev,
                    isRequestMultipleTime: e.target.checked
                  }))
                }
              >
                Yêu cầu gọi nhiều lần
              </Checkbox> */}
              <Checkbox
                checked={followUpOptions.isNotOnTime}
                onChange={(e) =>
                  setFollowUpOptions((prev) => ({
                    ...prev,
                    isNotOnTime: e.target.checked
                  }))
                }
              >
                ĐL không đến đúng hẹn
              </Checkbox>
              {requestItem?.serviceType?.code === 'baoMatDien' && (
                <Checkbox
                  checked={followUpOptions.isOutageEntireArea}
                  onChange={(e) =>
                    setFollowUpOptions((prev) => ({
                      ...prev,
                      isOutageEntireArea: e.target.checked
                    }))
                  }
                >
                  Mất điện cả khu vực
                </Checkbox>
              )}
              <Checkbox
                checked={followUpOptions.isNotRequestToSendSms}
                onChange={(e) =>
                  setFollowUpOptions((prev) => ({
                    ...prev,
                    isNotRequestToSendSms: e.target.checked
                  }))
                }
              >
                Không phải yêu cầu gửi tin nhắn
              </Checkbox>
            </div>
          </div>
        )}

        {/* {requestItem && requestItem?.ticketEvents.length > 0 ? (
          <>
            {isShow ? (
              requestItem?.ticketEvents.map((event, index) => (
                <>
                  <div className='relative mx-4 flex items-center justify-between'>
                    <div className={`absolute -left-4 top-[60%] rounded-full border bg-white p-2`}>
                      <BlueArrow />
                    </div>
                    <div className={`flex w-full items-center justify-between border-l pt-16`}>
                      <div className='mx-6 w-full'>
                        <Typography.Text className='text-[16px]/[18px] font-semibold text-[#141414]'>
                          {event.createdByName}
                        </Typography.Text>{' '}
                        <Typography.Text> {event.actionType?.name}</Typography.Text>
                        <br />
                        {(() => {
                          const formatDate = (date: string) => {
                            return date ? dayjs(date).format('DD [tháng] MM, YYYY - HH:mm') : '';
                          };

                          const formattedDate = formatDate(event.createdAt);

                          return (
                            <div className='text-[14px] italic text-[#141414]'>
                              {formattedDate.split('-')[1]}{' '}
                              <Typography.Text className='relative bottom-1 text-2xl'>.</Typography.Text>{' '}
                              {formattedDate.split('-')[0]}{' '}
                              <Typography.Text className='relative bottom-1 text-2xl'>.</Typography.Text>{' '}
                              {requestItem?.ticketEvents?.[index]?.organizationUnitName}
                            </div>
                          );
                        })()}
                      </div>
                      <Avatar name={requestItem?.ticketEvents[index].createdByName} size={32} />
                    </div>
                  </div>
                </>
              ))
            ) : (
              <div className='relative mx-4 flex items-center justify-between'>
                <div
                  className={`absolute -left-4 ${
                    requestItem?.status.code === 'CHOTIEPNHAN' ? 'top-[20%]' : ''
                  } rounded-full border bg-white p-2`}
                >
                  <BlueArrow />
                </div>
                <div
                  className={`flex w-full items-center justify-between border-l ${
                    requestItem?.status.code === 'CHOTIEPNHAN'
                      ? ''
                      : requestItem?.ticketEvents.length >= 2
                        ? 'py-8'
                        : 'pt-16'
                  }`}
                >
                  <div className='mx-6 w-full'>
                    <Typography.Text className='text-[16px]/[18px] font-semibold text-[#141414]'>
                      {requestItem?.ticketEvents[0].createdByName}
                    </Typography.Text>{' '}
                    <Typography.Text> {requestItem?.ticketEvents[0]?.actionType?.name}</Typography.Text>
                    <br />
                    {(() => {
                      const formatDate = (date: string) => {
                        return date ? dayjs(date).format('DD [tháng] MM, YYYY - HH:mm') : '';
                      };

                      const formattedDate = formatDate(requestItem?.ticketEvents?.[0]?.createdAt);

                      return (
                        <div className='text-[14px] italic text-[#141414]'>
                          {formattedDate.split('-')[1]}
                          <Typography.Text className='relative bottom-1 text-2xl'>.</Typography.Text>{' '}
                          {formattedDate.split('-')[0]}{' '}
                          <Typography.Text className='relative bottom-1 text-2xl'>.</Typography.Text>{' '}
                          {requestItem?.ticketEvents?.[0]?.organizationUnitName}
                        </div>
                      );
                    })()}
                  </div>
                  <Avatar name={requestItem?.ticketEvents[0].createdByName} size={32} />
                </div>
              </div>
            )}

            <div className='relative flex items-center'>
              {requestItem?.ticketEvents.length >= 2 ? (
                <>
                  {isShow ? (
                    ''
                  ) : (
                    <div className={`relative flex items-center`}>
                      <div>
                        <AntdAvatar.Group>
                          {requestItem?.ticketEvents
                            .slice(1, requestItem?.ticketEvents.length)
                            .map((avt, index) => (
                              <AntdAvatar
                                key={index}
                                src={<Avatar name={requestItem?.createdByName} size={32} />}
                                size={32}
                                alt={`Avatar ${index + 1}`}
                                className={`rounded-full border-2 border-white ${index !== 0 ? '-ml-5' : ''}`}
                              />
                            ))}
                        </AntdAvatar.Group>
                      </div>

                      <Button
                        className='text border-none bg-transparent text-[#1564E8] shadow-none'
                        onClick={setShowAll}
                      >
                        {ticketDetailedMessages.buttonShowAllHistoryProcess}
                      </Button>
                    </div>
                  )}
                </>
              ) : (
                ''
              )}
            </div>
          </>
        ) : (
          ' '
        )} */}
        {/* {events.length > 0 && (
          <>
            {(isShow ? events : [events[0]]).map((event, index) => (
              <EventItem key={index} event={event} orgName={event.organizationUnitName} createdBy={event.createdByName} />
            ))}

            {hasMultipleEvents && !isShow && (
              <div className='relative flex items-center'>
                <AntdAvatar.Group>
                  {events.slice(1).map((event, index) => (
                    <AntdAvatar
                      key={index}
                      src={<Avatar name={event.createdByName} size={32} />}
                      size={32}
                      alt={`Avatar ${index + 1}`}
                      className={`rounded-full border-2 border-white ${index !== 0 ? '-ml-5' : ''}`}
                    />
                  ))}
                </AntdAvatar.Group>
                <Button
                  className='text border-none bg-transparent text-[#1564E8] shadow-none'
                  onClick={() => setIsShow(true)}
                >
                  {ticketDetailedMessages.buttonShowAllHistoryProcess}
                </Button>
              </div>
            )}
          </>
        )} */}
        {Object.entries(groupedEvents).map(([batchUuid, batchEvents]) => (
          <div key={batchUuid} className='border-l pl-4 pb-6 relative mx-4'>
            {(batchEvents as TicketEventDto[]).map((event, eventIdx) => (
              <EventItem
                key={event.ticketEventId}
                event={event}
                isFirstEvent={eventIdx === 0}
              />
            ))}
          </div>
        ))}

        {!isShowAllEvents && remainingEvents.length > 0 && (
          <div className='relative flex items-center mt-2 ml-4'>
            <AntdAvatar.Group maxCount={5}>
              {remainingEvents.map((event, index) => (
                <AntdAvatar
                  key={index}
                  src={<Avatar name={event.createdByName} size={32} />}
                  size={32}
                  className={index !== 0 ? '-ml-5' : ''}
                />
              ))}
            </AntdAvatar.Group>
            <Button type='link' className='ml-4 text-[#1564E8] p-0 shadow-none' onClick={toggleShowAll}>
              Xem tất cả lịch sử xử lý
            </Button>
          </div>
        )}

        {isShowAllEvents && (
          <div className='relative flex items-center mt-2 ml-4'>
            <Button type='link' className='ml-4 text-[#1564E8] p-0 shadow-none' onClick={toggleShowAll}>
              Thu gọn lịch sử xử lý
            </Button>
          </div>
        )}

      </div>
    </Card>
  );
};

export default TicketDetailedIProcessing;
